import {BankAccount} from '@/types/client-info';

export const getMaskedBankAccount = ({transit, bankNo, folio}: BankAccount): string => {
  const safeTransit = replaceWithDotsUntil(transit, 2);
  const safeFolio = replaceWithDotsUntil(folio, 3);
  return `${safeTransit}-${bankNo}-${safeFolio}`;
};

const replaceWithDotsUntil = (str: string, indexFromEnd: number): string => {
  const indexDelimiter = Math.max(0, str.length - indexFromEnd);
  return '*'.repeat(indexDelimiter) + str.slice(indexDelimiter);
};
